import { getContactNameFromObject, type Contact } from '@rentguru/commons-utils';
import { orderBy } from 'lodash';

import type { OwnerStatementExtended } from 'src/components/Accounting/OwnerStatements/ownerStatementsUtils';

export enum OwnerStatementsSortOptions {
  NAME_ASC,
  NAME_DES,
  UNITS_ASC,
  UNITS_DES,
  GROSS_ACCOUNT_BALANCE_ASC,
  GROSS_ACCOUNT_BALANCE_DES,
  NET_AVAILABLE_BALANCE_ASC,
  NET_AVAILABLE_BALANCE_DES,
}
export enum StatementDialogs {
  VALIDATE,
  MORE,
  DELETE,
}

export const sortOwners = (owners: OwnersItem[], sortOption: OwnerStatementsSortOptions) => {
  switch (sortOption) {
    case OwnerStatementsSortOptions.NAME_ASC:
      return orderBy(owners, (owner) => getContactNameFromObject(owner.contact), ['asc']);
    case OwnerStatementsSortOptions.NAME_DES:
      return orderBy(owners, (owner) => getContactNameFromObject(owner.contact), ['desc']);
    case OwnerStatementsSortOptions.UNITS_ASC:
      return orderBy(owners, (owner) => owner.contact?.units?.length, ['asc']);
    case OwnerStatementsSortOptions.UNITS_DES:
      return orderBy(owners, (owner) => owner.contact?.units?.length, ['desc']);
    case OwnerStatementsSortOptions.GROSS_ACCOUNT_BALANCE_ASC:
      return orderBy(owners, (owner) => owner.grossAccountBalance, ['asc']);
    case OwnerStatementsSortOptions.GROSS_ACCOUNT_BALANCE_DES:
      return orderBy(owners, (owner) => owner.grossAccountBalance, ['desc']);
    case OwnerStatementsSortOptions.NET_AVAILABLE_BALANCE_ASC:
      return orderBy(owners, (owner) => owner.netAvailableBalance, ['asc']);
    case OwnerStatementsSortOptions.NET_AVAILABLE_BALANCE_DES:
      return orderBy(owners, (owner) => owner.netAvailableBalance, ['desc']);
    default:
      return owners;
  }
};

export interface OwnersItem {
  id: string;
  contact: Contact;
  statement?: OwnerStatementExtended;
  grossAccountBalance?: number;
  netAvailableBalance?: number;
}
